import { evictSwrCacheEntries } from './swrCacheEviction'

/**
 * Thin wrapper around `localStorage` with automatic QuotaExceededError recovery.
 * On quota error: evicts all SWR cache entries and retries once.
 * Re-throws non-quota errors. Lets retry errors propagate.
 */
export const ippLocalStorage = {
  setItem: (key: string, value: string): void => {
    try {
      localStorage.setItem(key, value)
    } catch (err) {
      if (err instanceof DOMException && err.name === 'QuotaExceededError') {
        // Evict all SWR entries to free space
        evictSwrCacheEntries({ maxEntriesToEvict: Infinity })
        // Retry once — let any error propagate
        localStorage.setItem(key, value)
      } else {
        throw err
      }
    }
  },
}
